import { variant } from 'styled-system'

const placementVariant = variant({
  prop: 'placement',
  variants: {
    bottom: {
      left: '50%',
      transform: 'translateX(-50%)',
    },
    'bottom-right': {
      right: '0px',
    },
    top: {
      left: '50%',
      transform: 'translate(-50%, -200%)',
    },
    'top-right': {
      right: '0px',
      transform: 'translateY(-200%)',
    },
    right: {
      right: '0px',
      transform: 'translate(101%, -100%)',
    },
  },
})

const whitespace = variant({
  prop: 'whitespace',
  variants: {
    nowrap: {
      whiteSpace: 'nowrap',
    },
    default: {
      whiteSpace: 'normal',
    },
  },
})

export { placementVariant, whitespace }
